<template>
  <AtomLink :url="url" class="flex flex-col w-full rounded-t-xl overflow-hidden">
    <figure>
      <MoleculePicture :image="image" />
    </figure>
    <div class="flex flex-auto px-6 py-5 bg-white border-t-2 border-app-lime rounded-b-xl">
      <div class="flex flex-col items-start">
        <div class="flex-auto">
          <h4 class="font-bold">{{ title }}</h4>
          <div v-if="summary" class="prose prose--app mb-10" v-html="truncate(stripTags(summary), { length: 256 })" />
        </div>
        <AtomLinkWithIcon title="Lees dit verhaal" class="mt-4 mt-auto font-bold">Lees dit verhaal</AtomLinkWithIcon>
      </div>
    </div>
  </AtomLink>
</template>

<script setup lang="ts">
import { stripTags, truncate } from '~/composables/util'

interface Props {
  url?: string
  image: object
  title: string
  summary?: string
}

defineProps<Props>()
</script>
